const isNativeApp = () => {
  const params = new URLSearchParams(window.location.search);
  const appPlatform = params.get("app_platform");
  const appPlatforms = ["ios", "android"];
  return appPlatforms.includes(appPlatform);
};

export const isWebView = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    isNativeApp() ||
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent) ||
    /Version\/[\d.]+.*Chrome\/[\d.]+.*Mobile/i.test(navigator.userAgent) ||
    (/(Android)(?!.*Mobile)/i.test(navigator.userAgent) &&
      /wv/i.test(navigator.userAgent))
  );
};
